import type { DashboardFilters } from "@/types";

export const DASHBOARD_KEY = "DASHBOARD";

export const DASHBOARD_CACHE_KEYS = {
  GET: (filters: DashboardFilters) => [DASHBOARD_KEY, filters] as const,
};
